var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { getSdaData } from "../utils/getSdaData.function";
import { ComputeBudgetProgram, SYSVAR_INSTRUCTIONS_PUBKEY, SystemProgram, } from "@solana/web3.js";
import { findOrCreateAta } from "../utils/findOrCreateAta.function";
import { TOKEN_2022_PROGRAM_ID, TOKEN_PROGRAM_ID } from "@solana/spl-token";
import { METAPLEX_AUTH_RULES_PROGRAM, NS_FEE, SOLANA_SPL_ATA_PROGRAM_ID, TOKEN_METADATA_PROGRAM, VERSION, } from "../utils/const";
import { findNftDataAndMetadataAccount, findPnftAccounts, getCoreCollection, getHashlistMarker, whichStandard, } from "../utils/findNftDataAndAccounts.function";
import { TokenStandard } from "@metaplex-foundation/mpl-token-metadata";
import { getCreatorData } from "../utils/creators";
import { bidToscBid } from "../utils/typeSwap";
import { DESC } from "../utils/descriptions";
import { WRAPPED_SOL_MINT } from "@metaplex-foundation/js";
import { addWSol, closeWSol } from "../utils/wsol";
import { ix2vTx } from "../utils/vtx";
import { checkEnvOpts, getTakeArgs } from "../utils/check";
import { MPL_CORE_PROGRAM_ID } from "@metaplex-foundation/mpl-core";
import { takerFee } from "../utils/fees";
export function createTakeAndCloseSwapInstructions(Data) {
    return __awaiter(this, void 0, void 0, function () {
        var cEnvOpts, takeArgs, program, connection, taker, swapDataAccount, bid, nftMintTaker, verifyTaker, signer, n, unwrap, takeIxs, claimIxs, payRAndCloseSIxs, swapDataData, paymentMint, maker, nftMintMaker, bids, acceptedBid, royaltiesPaidMaker, royaltiesPaidTaker, claimed, foundBid, makerNftStd, takerNftStd, _a, takerTokenAta, takerTokenIx, _b, swapDataAccountTokenAta, sdaTokenIx, _c, makerTokenAta, makerTokenIx, _d, nsFeeTokenAta, nsTokenIx, _e, swapDataAccountNftAta, sdaAtaMakerNftIx, nftMetadataMaker, tokenStandardMaker, _f, nftMetadataMaker2, tokenStandardMaker2, nftMetadataTaker, tokenStandardTaker, _g, nftMetadataTaker2, tokenStandardTaker2, amount, takerCoreCollection, takeIx, _h, makerNftAta, makerAtaMakerNftIx, _j, takerNftAta, takerAtaMakerNftIx, nftMasterEditionTaker, ownerTokenRecordTaker, destinationTokenRecordTaker, authRulesTaker, takeIx, makerhashlistMarker, takeIx, coreCollection, claimCoreIx, _k, takerNftAtaMaker, takerAtaMakerNftIx, nftMasterEditionMaker, ownerTokenRecordMaker, destinationTokenRecordMaker, authRulesMaker, claimIx, claimIx, _l, makerCreators, makerCreatorTokenAta, creatorIxs, payTakerCoreIx, _m, makerCreator, makerCreatorTokenAta, creatorIxs, payRIx, payRIx, _o, makerCreators, makerCreatorTokenAta, creatorIxs, payTakerCoreIx, _p, takerCreator, takerCreatorTokenAta, creatorIxs, payRIx, payRIx, closeIx, takeTx, claimTx, _q, blockheight, blockhash_1, bTTakeAndClose, priority, _r, _s, error_1;
        var _t, _u, _v;
        return __generator(this, function (_w) {
            switch (_w.label) {
                case 0:
                    console.log(VERSION);
                    return [4 /*yield*/, checkEnvOpts(Data)];
                case 1:
                    cEnvOpts = _w.sent();
                    takeArgs = getTakeArgs(Data);
                    program = cEnvOpts.program, connection = cEnvOpts.connection;
                    taker = takeArgs.taker, swapDataAccount = takeArgs.swapDataAccount, bid = takeArgs.bid, nftMintTaker = takeArgs.nftMintTaker, verifyTaker = takeArgs.verifyTaker, signer = takeArgs.signer, n = takeArgs.n, unwrap = takeArgs.unwrap;
                    if (!n)
                        n = 0;
                    if (!signer) {
                        console.log("no signer", taker);
                        signer = taker;
                    }
                    else
                        console.log("signer", signer, "taker", taker);
                    takeIxs = [
                        ComputeBudgetProgram.setComputeUnitLimit({
                            units: 8500000,
                        }),
                    ];
                    claimIxs = [
                        ComputeBudgetProgram.setComputeUnitLimit({
                            units: 8500000,
                        }),
                    ];
                    payRAndCloseSIxs = [
                        ComputeBudgetProgram.setComputeUnitLimit({
                            units: 8500000,
                        }),
                    ];
                    _w.label = 2;
                case 2:
                    _w.trys.push([2, 68, , 69]);
                    return [4 /*yield*/, getSdaData({
                            program: program,
                            swapDataAccount: swapDataAccount,
                        })];
                case 3:
                    swapDataData = _w.sent();
                    if (!swapDataData)
                        throw "no swapData found at " + swapDataAccount;
                    paymentMint = swapDataData.paymentMint, maker = swapDataData.maker, nftMintMaker = swapDataData.nftMintMaker, bids = swapDataData.bids, acceptedBid = swapDataData.acceptedBid, royaltiesPaidMaker = swapDataData.royaltiesPaidMaker, royaltiesPaidTaker = swapDataData.royaltiesPaidTaker, claimed = swapDataData.claimed;
                    if (verifyTaker && swapDataData.taker && swapDataData.taker !== taker)
                        throw "signer is not the taker of this swap";
                    foundBid = bids.find(function (b) {
                        return b.amount === bid.amount &&
                            b.collection === bid.collection &&
                            b.takerNeoswapFee === bid.takerNeoswapFee &&
                            b.takerRoyalties === bid.takerRoyalties &&
                            b.makerRoyalties === bid.makerRoyalties &&
                            b.makerNeoswapFee === bid.makerNeoswapFee;
                    });
                    if (!foundBid)
                        throw "bid ".concat(JSON.stringify(Data.bid), " not found in ").concat(JSON.stringify(bids), " ");
                    return [4 /*yield*/, whichStandard({ connection: connection, mint: nftMintMaker })];
                case 4:
                    makerNftStd = _w.sent();
                    return [4 /*yield*/, whichStandard({ connection: connection, mint: nftMintTaker })];
                case 5:
                    takerNftStd = _w.sent();
                    return [4 /*yield*/, findOrCreateAta({
                            connection: connection,
                            mint: paymentMint,
                            owner: taker,
                            signer: signer,
                        })];
                case 6:
                    _a = _w.sent(), takerTokenAta = _a.mintAta, takerTokenIx = _a.instruction;
                    if (takerTokenIx) {
                        takeIxs.push(takerTokenIx);
                        claimIxs.push(takerTokenIx);
                    }
                    else
                        console.log("takerTokenAta", takerTokenAta);
                    return [4 /*yield*/, findOrCreateAta({
                            connection: connection,
                            mint: paymentMint,
                            owner: swapDataAccount,
                            signer: signer,
                        })];
                case 7:
                    _b = _w.sent(), swapDataAccountTokenAta = _b.mintAta, sdaTokenIx = _b.instruction;
                    return [4 /*yield*/, findOrCreateAta({
                            connection: connection,
                            mint: paymentMint,
                            owner: maker,
                            signer: signer,
                        })];
                case 8:
                    _c = _w.sent(), makerTokenAta = _c.mintAta, makerTokenIx = _c.instruction;
                    if (makerTokenIx) {
                        takeIxs.push(makerTokenIx);
                        claimIxs.push(makerTokenIx);
                    }
                    else
                        console.log("makerTokenAta", makerTokenAta);
                    return [4 /*yield*/, findOrCreateAta({
                            connection: connection,
                            mint: paymentMint,
                            owner: NS_FEE,
                            signer: signer,
                        })];
                case 9:
                    _d = _w.sent(), nsFeeTokenAta = _d.mintAta, nsTokenIx = _d.instruction;
                    if (nsTokenIx)
                        claimIxs.push(nsTokenIx);
                    else
                        console.log("nsFeeTokenAta", nsFeeTokenAta);
                    return [4 /*yield*/, findOrCreateAta({
                            connection: connection,
                            mint: nftMintMaker,
                            owner: swapDataAccount,
                            signer: signer,
                        })];
                case 10:
                    _e = _w.sent(), swapDataAccountNftAta = _e.mintAta, sdaAtaMakerNftIx = _e.instruction;
                    nftMetadataMaker = null;
                    tokenStandardMaker = null;
                    if (!(makerNftStd === "native")) return [3 /*break*/, 12];
                    console.log("makerNftStdmakerNftStdmakerNftStdmakerNftStdmakerNftStd", makerNftStd);
                    return [4 /*yield*/, findNftDataAndMetadataAccount({
                            connection: connection,
                            mint: nftMintMaker,
                        })];
                case 11:
                    _f = _w.sent(), nftMetadataMaker2 = _f.metadataAddress, tokenStandardMaker2 = _f.tokenStandard;
                    nftMetadataMaker = nftMetadataMaker2;
                    tokenStandardMaker = tokenStandardMaker2 ? tokenStandardMaker2 : null;
                    _w.label = 12;
                case 12:
                    nftMetadataTaker = null;
                    tokenStandardTaker = null;
                    if (!(takerNftStd === "native")) return [3 /*break*/, 14];
                    return [4 /*yield*/, findNftDataAndMetadataAccount({
                            connection: connection,
                            mint: nftMintTaker,
                        })];
                case 13:
                    _g = _w.sent(), nftMetadataTaker2 = _g.metadataAddress, tokenStandardTaker2 = _g.tokenStandard;
                    nftMetadataTaker = nftMetadataTaker2;
                    tokenStandardTaker = tokenStandardTaker2 ? tokenStandardTaker2 : null;
                    _w.label = 14;
                case 14:
                    if (!!acceptedBid) return [3 /*break*/, 28];
                    if (swapDataData.paymentMint === WRAPPED_SOL_MINT.toString()) {
                        amount = takerFee({ bid: bid, n: n });
                        if (amount > 0)
                            takeIxs.push.apply(takeIxs, addWSol(taker, takerTokenAta, amount));
                    }
                    if (!(takerNftStd == "core")) return [3 /*break*/, 17];
                    return [4 /*yield*/, getCoreCollection({
                            connection: connection,
                            mint: nftMintTaker,
                        })];
                case 15:
                    takerCoreCollection = _w.sent();
                    return [4 /*yield*/, program.methods
                            .takeSwapCore(bidToscBid(bid), n)
                            .accountsStrict({
                            swapDataAccount: swapDataAccount,
                            swapDataAccountTokenAta: swapDataAccountTokenAta,
                            maker: maker,
                            makerTokenAta: makerTokenAta,
                            taker: taker,
                            takerTokenAta: takerTokenAta,
                            nftMintTaker: nftMintTaker,
                            paymentMint: paymentMint,
                            collection: takerCoreCollection,
                            coreProgram: MPL_CORE_PROGRAM_ID,
                            sysvarInstructions: SYSVAR_INSTRUCTIONS_PUBKEY,
                            tokenProgram: TOKEN_PROGRAM_ID,
                        })
                            .instruction()];
                case 16:
                    takeIx = _w.sent();
                    takeIxs.push(takeIx);
                    return [3 /*break*/, 28];
                case 17: return [4 /*yield*/, findOrCreateAta({
                        connection: connection,
                        mint: nftMintTaker,
                        owner: maker,
                        signer: signer,
                    })];
                case 18:
                    _h = _w.sent(), makerNftAta = _h.mintAta, makerAtaMakerNftIx = _h.instruction;
                    if (makerAtaMakerNftIx)
                        takeIxs.push(makerAtaMakerNftIx);
                    else
                        console.log("makerNftAta", makerNftAta);
                    return [4 /*yield*/, findOrCreateAta({
                            connection: connection,
                            mint: nftMintTaker,
                            owner: taker,
                            signer: signer,
                        })];
                case 19:
                    _j = _w.sent(), takerNftAta = _j.mintAta, takerAtaMakerNftIx = _j.instruction;
                    if (takerAtaMakerNftIx)
                        takeIxs.push(takerAtaMakerNftIx);
                    else
                        console.log("takerNftAta", takerNftAta);
                    if (!(takerNftStd === "native")) return [3 /*break*/, 25];
                    nftMasterEditionTaker = null;
                    ownerTokenRecordTaker = null;
                    destinationTokenRecordTaker = null;
                    authRulesTaker = null;
                    if (!(tokenStandardTaker == TokenStandard.ProgrammableNonFungible)) return [3 /*break*/, 21];
                    return [4 /*yield*/, findPnftAccounts({
                            connection: connection,
                            destinationAta: makerNftAta,
                            mint: nftMintTaker,
                            ownerAta: takerNftAta,
                        })];
                case 20:
                    (_t = _w.sent(), authRulesTaker = _t.authRules, destinationTokenRecordTaker = _t.destinationTokenRecord, nftMasterEditionTaker = _t.masterEdition, ownerTokenRecordTaker = _t.ownerTokenRecord);
                    _w.label = 21;
                case 21:
                    if (!!nftMetadataTaker) return [3 /*break*/, 23];
                    return [4 /*yield*/, findNftDataAndMetadataAccount({
                            connection: connection,
                            mint: nftMintTaker,
                        })];
                case 22:
                    nftMetadataTaker = (_w.sent()).metadataAddress;
                    _w.label = 23;
                case 23: return [4 /*yield*/, program.methods
                        .takeSwap(bidToscBid(bid), n)
                        .accountsStrict({
                        swapDataAccount: swapDataAccount,
                        swapDataAccountTokenAta: swapDataAccountTokenAta,
                        maker: maker,
                        makerNftAta: makerNftAta,
                        makerTokenAta: makerTokenAta,
                        taker: taker,
                        takerNftAta: takerNftAta,
                        takerTokenAta: takerTokenAta,
                        nftMintTaker: nftMintTaker,
                        paymentMint: paymentMint,
                        nftMetadataTaker: nftMetadataTaker,
                        nftMasterEditionTaker: nftMasterEditionTaker,
                        ownerTokenRecordTaker: ownerTokenRecordTaker,
                        destinationTokenRecordTaker: destinationTokenRecordTaker,
                        authRulesTaker: authRulesTaker,
                        systemProgram: SystemProgram.programId,
                        metadataProgram: TOKEN_METADATA_PROGRAM,
                        sysvarInstructions: SYSVAR_INSTRUCTIONS_PUBKEY,
                        tokenProgram: TOKEN_PROGRAM_ID,
                        ataProgram: SOLANA_SPL_ATA_PROGRAM_ID,
                        authRulesProgram: METAPLEX_AUTH_RULES_PROGRAM,
                    })
                        .instruction()];
                case 24:
                    takeIx = _w.sent();
                    takeIxs.push(takeIx);
                    return [3 /*break*/, 28];
                case 25: return [4 /*yield*/, getHashlistMarker({
                        collection: Data.bid.collection,
                        nftMintTaker: nftMintTaker,
                    })];
                case 26:
                    makerhashlistMarker = _w.sent();
                    console.log("makerhashlistMarker", makerhashlistMarker);
                    return [4 /*yield*/, program.methods
                            .takeSwap22(bidToscBid(Data.bid), n)
                            .accountsStrict({
                            swapDataAccount: swapDataAccount,
                            swapDataAccountTokenAta: swapDataAccountTokenAta,
                            maker: maker,
                            makerNftAta: makerNftAta,
                            makerTokenAta: makerTokenAta,
                            taker: taker,
                            takerNftAta: takerNftAta,
                            takerTokenAta: takerTokenAta,
                            nftMintTaker: nftMintTaker,
                            paymentMint: paymentMint,
                            hashlistMarker: makerhashlistMarker,
                            systemProgram: SystemProgram.programId,
                            tokenProgram: TOKEN_PROGRAM_ID,
                            tokenProgram22: TOKEN_2022_PROGRAM_ID,
                            ataProgram: SOLANA_SPL_ATA_PROGRAM_ID,
                        })
                            .instruction()];
                case 27:
                    takeIx = _w.sent();
                    takeIxs.push(takeIx);
                    _w.label = 28;
                case 28:
                    if (!!claimed) return [3 /*break*/, 40];
                    if (!(makerNftStd === "core")) return [3 /*break*/, 31];
                    return [4 /*yield*/, getCoreCollection({ mint: nftMintMaker, connection: connection })];
                case 29:
                    coreCollection = _w.sent();
                    return [4 /*yield*/, program.methods
                            .claimSwapCore()
                            .accountsStrict({
                            ataProgram: SOLANA_SPL_ATA_PROGRAM_ID,
                            nsFee: NS_FEE,
                            nsFeeTokenAta: nsFeeTokenAta,
                            signer: signer,
                            taker: taker,
                            takerTokenAta: takerTokenAta,
                            collection: coreCollection,
                            maker: maker,
                            makerTokenAta: makerTokenAta,
                            nftMintMaker: nftMintMaker,
                            paymentMint: paymentMint,
                            swapDataAccountTokenAta: swapDataAccountTokenAta,
                            tokenProgram: TOKEN_PROGRAM_ID.toString(),
                            coreProgram: MPL_CORE_PROGRAM_ID.toString(),
                            swapDataAccount: swapDataAccount,
                            systemProgram: SystemProgram.programId.toString(),
                        })
                            .instruction()];
                case 30:
                    claimCoreIx = _w.sent();
                    claimIxs.push(claimCoreIx);
                    return [3 /*break*/, 40];
                case 31: return [4 /*yield*/, findOrCreateAta({
                        connection: connection,
                        mint: nftMintMaker,
                        owner: taker,
                        signer: signer,
                    })];
                case 32:
                    _k = _w.sent(), takerNftAtaMaker = _k.mintAta, takerAtaMakerNftIx = _k.instruction;
                    if (takerAtaMakerNftIx)
                        claimIxs.push(takerAtaMakerNftIx);
                    else
                        console.log("takerNftAta", takerNftAtaMaker);
                    if (!(makerNftStd === "native")) return [3 /*break*/, 38];
                    nftMasterEditionMaker = null;
                    ownerTokenRecordMaker = null;
                    destinationTokenRecordMaker = null;
                    authRulesMaker = null;
                    if (!(tokenStandardMaker == TokenStandard.ProgrammableNonFungible)) return [3 /*break*/, 34];
                    return [4 /*yield*/, findPnftAccounts({
                            connection: connection,
                            destinationAta: takerNftAtaMaker,
                            mint: nftMintMaker,
                            ownerAta: swapDataAccountNftAta,
                        })];
                case 33:
                    (_u = _w.sent(), authRulesMaker = _u.authRules, destinationTokenRecordMaker = _u.destinationTokenRecord, nftMasterEditionMaker = _u.masterEdition, ownerTokenRecordMaker = _u.ownerTokenRecord);
                    _w.label = 34;
                case 34:
                    if (!!nftMetadataMaker) return [3 /*break*/, 36];
                    return [4 /*yield*/, findNftDataAndMetadataAccount({
                            connection: connection,
                            mint: nftMintMaker,
                        })];
                case 35:
                    nftMetadataMaker = (_w.sent()).metadataAddress;
                    _w.label = 36;
                case 36: return [4 /*yield*/, program.methods
                        .claimSwap()
                        .accountsStrict({
                        swapDataAccount: swapDataAccount,
                        swapDataAccountNftAta: swapDataAccountNftAta,
                        swapDataAccountTokenAta: swapDataAccountTokenAta,
                        nsFee: NS_FEE,
                        nsFeeTokenAta: nsFeeTokenAta,
                        signer: signer,
                        taker: taker,
                        takerNftAtaMaker: takerNftAtaMaker,
                        takerTokenAta: takerTokenAta,
                        maker: maker,
                        makerTokenAta: makerTokenAta,
                        nftMintMaker: nftMintMaker,
                        paymentMint: paymentMint,
                        nftMetadataMaker: nftMetadataMaker,
                        nftMasterEditionMaker: nftMasterEditionMaker,
                        ownerTokenRecordMaker: ownerTokenRecordMaker,
                        destinationTokenRecordMaker: destinationTokenRecordMaker,
                        authRulesMaker: authRulesMaker,
                        systemProgram: SystemProgram.programId,
                        metadataProgram: TOKEN_METADATA_PROGRAM,
                        sysvarInstructions: SYSVAR_INSTRUCTIONS_PUBKEY,
                        tokenProgram: TOKEN_PROGRAM_ID,
                        ataProgram: SOLANA_SPL_ATA_PROGRAM_ID,
                        authRulesProgram: METAPLEX_AUTH_RULES_PROGRAM,
                    })
                        .instruction()];
                case 37:
                    claimIx = _w.sent();
                    claimIxs.push(claimIx);
                    return [3 /*break*/, 40];
                case 38: return [4 /*yield*/, program.methods
                        .claimSwap22()
                        .accountsStrict({
                        swapDataAccount: swapDataAccount,
                        swapDataAccountNftAta: swapDataAccountNftAta,
                        swapDataAccountTokenAta: swapDataAccountTokenAta,
                        nsFee: NS_FEE,
                        nsFeeTokenAta: nsFeeTokenAta,
                        signer: signer,
                        taker: taker,
                        takerNftAtaMaker: takerNftAtaMaker,
                        takerTokenAta: takerTokenAta,
                        maker: maker,
                        makerTokenAta: makerTokenAta,
                        nftMintMaker: nftMintMaker,
                        paymentMint: paymentMint,
                        systemProgram: SystemProgram.programId,
                        sysvarInstructions: SYSVAR_INSTRUCTIONS_PUBKEY,
                        tokenProgram: TOKEN_PROGRAM_ID,
                        tokenProgram22: TOKEN_2022_PROGRAM_ID,
                        ataProgram: SOLANA_SPL_ATA_PROGRAM_ID,
                    })
                        .instruction()];
                case 39:
                    claimIx = _w.sent();
                    claimIxs.push(claimIx);
                    _w.label = 40;
                case 40:
                    if (!!royaltiesPaidTaker) return [3 /*break*/, 50];
                    console.log("royaltiesPaidTaker", makerNftStd);
                    if (!(makerNftStd === "core")) return [3 /*break*/, 43];
                    return [4 /*yield*/, getCreatorData({
                            connection: connection,
                            nftMint: nftMintMaker,
                            owner: swapDataAccount,
                            paymentMint: paymentMint,
                            signer: signer,
                            tokenStandard: makerNftStd,
                        })];
                case 41:
                    _l = _w.sent(), makerCreators = _l.creators, makerCreatorTokenAta = _l.creatorTokenAta, creatorIxs = _l.instructions;
                    return [4 /*yield*/, program.methods
                            .payRoyaltiesCore()
                            .accountsStrict({
                            swapDataAccount: swapDataAccount,
                            swapDataAccountTokenAta: swapDataAccountTokenAta,
                            nftMint: nftMintMaker,
                            paymentMint: paymentMint,
                            signer: signer,
                            // nsFee: NS_FEE,
                            // nsFeeTokenAta,
                            creator0: makerCreators[0],
                            creator0TokenAta: makerCreatorTokenAta[0],
                            creator1: makerCreators[1],
                            creator1TokenAta: makerCreatorTokenAta[1],
                            creator2: makerCreators[2],
                            creator2TokenAta: makerCreatorTokenAta[2],
                            creator3: makerCreators[3],
                            creator3TokenAta: makerCreatorTokenAta[3],
                            creator4: makerCreators[4],
                            creator4TokenAta: makerCreatorTokenAta[4],
                            tokenProgram: TOKEN_PROGRAM_ID,
                        })
                            .instruction()];
                case 42:
                    payTakerCoreIx = _w.sent();
                    payRAndCloseSIxs.push.apply(payRAndCloseSIxs, creatorIxs);
                    payRAndCloseSIxs.push(payTakerCoreIx);
                    return [3 /*break*/, 50];
                case 43:
                    if (!(makerNftStd === "native")) return [3 /*break*/, 48];
                    return [4 /*yield*/, getCreatorData({
                            connection: connection,
                            nftMint: nftMintMaker,
                            paymentMint: paymentMint,
                            owner: swapDataAccount,
                            signer: signer,
                            tokenStandard: makerNftStd,
                        })];
                case 44:
                    _m = _w.sent(), makerCreator = _m.creators, makerCreatorTokenAta = _m.creatorTokenAta, creatorIxs = _m.instructions;
                    if (creatorIxs.length > 0) {
                        console.log("creatorIxs", creatorIxs.length);
                        payRAndCloseSIxs.push.apply(payRAndCloseSIxs, creatorIxs);
                    }
                    if (!!nftMetadataMaker) return [3 /*break*/, 46];
                    return [4 /*yield*/, findNftDataAndMetadataAccount({
                            connection: connection,
                            mint: nftMintMaker,
                        })];
                case 45:
                    nftMetadataMaker = (_w.sent()).metadataAddress;
                    _w.label = 46;
                case 46: return [4 /*yield*/, program.methods
                        .payRoyalties()
                        .accountsStrict({
                        swapDataAccount: swapDataAccount,
                        swapDataAccountTokenAta: swapDataAccountTokenAta,
                        paymentMint: paymentMint,
                        signer: signer,
                        // nsFee: NS_FEE,
                        // nsFeeTokenAta,
                        nftMetadata: nftMetadataMaker,
                        nftMint: nftMintMaker,
                        metadataProgram: TOKEN_METADATA_PROGRAM,
                        tokenProgram: TOKEN_PROGRAM_ID.toString(),
                        creator0: makerCreator[0],
                        creator0TokenAta: makerCreatorTokenAta[0],
                        creator1: makerCreator[1],
                        creator1TokenAta: makerCreatorTokenAta[1],
                        creator2: makerCreator[2],
                        creator2TokenAta: makerCreatorTokenAta[2],
                        creator3: makerCreator[3],
                        creator3TokenAta: makerCreatorTokenAta[3],
                        creator4: makerCreator[4],
                        creator4TokenAta: makerCreatorTokenAta[4],
                    })
                        .instruction()];
                case 47:
                    payRIx = _w.sent();
                    payRAndCloseSIxs.push(payRIx);
                    return [3 /*break*/, 50];
                case 48: return [4 /*yield*/, program.methods
                        .payRoyalties22()
                        .accountsStrict({
                        swapDataAccount: swapDataAccount,
                        // swapDataAccountTokenAta,
                        nftMint: nftMintMaker,
                        signer: signer,
                        // nsFee: NS_FEE,
                        // nsFeeTokenAta,
                        tokenProgram22: TOKEN_2022_PROGRAM_ID,
                        // tokenProgram: TOKEN_PROGRAM_ID,
                    })
                        .instruction()];
                case 49:
                    payRIx = _w.sent();
                    payRAndCloseSIxs.push(payRIx);
                    _w.label = 50;
                case 50:
                    if (!!royaltiesPaidMaker) return [3 /*break*/, 60];
                    console.log("royaltiesPaidMaker", takerNftStd);
                    if (!(takerNftStd === "core")) return [3 /*break*/, 53];
                    return [4 /*yield*/, getCreatorData({
                            connection: connection,
                            nftMint: nftMintTaker,
                            owner: swapDataAccount,
                            paymentMint: paymentMint,
                            signer: signer,
                            tokenStandard: takerNftStd,
                        })];
                case 51:
                    _o = _w.sent(), makerCreators = _o.creators, makerCreatorTokenAta = _o.creatorTokenAta, creatorIxs = _o.instructions;
                    return [4 /*yield*/, program.methods
                            .payRoyaltiesCore()
                            .accountsStrict({
                            swapDataAccount: swapDataAccount,
                            swapDataAccountTokenAta: swapDataAccountTokenAta,
                            nftMint: nftMintTaker,
                            paymentMint: paymentMint,
                            signer: signer,
                            // nsFee: NS_FEE,
                            // nsFeeTokenAta,
                            creator0: makerCreators[0],
                            creator0TokenAta: makerCreatorTokenAta[0],
                            creator1: makerCreators[1],
                            creator1TokenAta: makerCreatorTokenAta[1],
                            creator2: makerCreators[2],
                            creator2TokenAta: makerCreatorTokenAta[2],
                            creator3: makerCreators[3],
                            creator3TokenAta: makerCreatorTokenAta[3],
                            creator4: makerCreators[4],
                            creator4TokenAta: makerCreatorTokenAta[4],
                            tokenProgram: TOKEN_PROGRAM_ID,
                        })
                            .instruction()];
                case 52:
                    payTakerCoreIx = _w.sent();
                    payRAndCloseSIxs.push.apply(payRAndCloseSIxs, creatorIxs);
                    payRAndCloseSIxs.push(payTakerCoreIx);
                    return [3 /*break*/, 60];
                case 53:
                    if (!(takerNftStd === "native")) return [3 /*break*/, 58];
                    return [4 /*yield*/, getCreatorData({
                            connection: connection,
                            paymentMint: paymentMint,
                            owner: swapDataAccount,
                            signer: signer,
                            nftMint: nftMintTaker,
                            tokenStandard: takerNftStd,
                        })];
                case 54:
                    _p = _w.sent(), takerCreator = _p.creators, takerCreatorTokenAta = _p.creatorTokenAta, creatorIxs = _p.instructions;
                    if (creatorIxs)
                        payRAndCloseSIxs.push.apply(payRAndCloseSIxs, creatorIxs);
                    if (!!nftMetadataTaker) return [3 /*break*/, 56];
                    return [4 /*yield*/, findNftDataAndMetadataAccount({
                            connection: connection,
                            mint: nftMintTaker,
                        })];
                case 55:
                    nftMetadataTaker = (_w.sent()).metadataAddress;
                    _w.label = 56;
                case 56: return [4 /*yield*/, program.methods
                        .payRoyalties()
                        .accountsStrict({
                        swapDataAccount: swapDataAccount,
                        swapDataAccountTokenAta: swapDataAccountTokenAta,
                        paymentMint: paymentMint,
                        signer: signer,
                        // nsFee: NS_FEE,
                        // nsFeeTokenAta,
                        nftMint: nftMintTaker,
                        nftMetadata: nftMetadataTaker,
                        metadataProgram: TOKEN_METADATA_PROGRAM,
                        tokenProgram: TOKEN_PROGRAM_ID,
                        creator0: takerCreator[0],
                        creator0TokenAta: takerCreatorTokenAta[0],
                        creator1: takerCreator[1],
                        creator1TokenAta: takerCreatorTokenAta[1],
                        creator2: takerCreator[2],
                        creator2TokenAta: takerCreatorTokenAta[2],
                        creator3: takerCreator[3],
                        creator3TokenAta: takerCreatorTokenAta[3],
                        creator4: takerCreator[4],
                        creator4TokenAta: takerCreatorTokenAta[4],
                    })
                        .instruction()];
                case 57:
                    payRIx = _w.sent();
                    payRAndCloseSIxs.push(payRIx);
                    return [3 /*break*/, 60];
                case 58: return [4 /*yield*/, program.methods
                        .payRoyalties22()
                        .accountsStrict({
                        swapDataAccount: swapDataAccount,
                        // swapDataAccountTokenAta,
                        nftMint: nftMintTaker,
                        signer: signer,
                        // nsFee: NS_FEE,
                        // nsFeeTokenAta,
                        tokenProgram22: TOKEN_2022_PROGRAM_ID,
                        // tokenProgram: TOKEN_PROGRAM_ID,
                    })
                        .instruction()];
                case 59:
                    payRIx = _w.sent();
                    payRAndCloseSIxs.push(payRIx);
                    _w.label = 60;
                case 60: return [4 /*yield*/, program.methods
                        .closeSwap()
                        .accountsStrict({
                        swapDataAccount: swapDataAccount,
                        swapDataAccountTokenAta: swapDataAccountTokenAta,
                        // swapDataAccountNftAta,
                        maker: maker,
                        makerTokenAta: makerTokenAta,
                        paymentMint: paymentMint,
                        signer: signer,
                        systemProgram: SystemProgram.programId,
                        tokenProgram: TOKEN_PROGRAM_ID,
                    })
                        .instruction()];
                case 61:
                    closeIx = _w.sent();
                    payRAndCloseSIxs.push(closeIx);
                    if (swapDataData.paymentMint === WRAPPED_SOL_MINT.toString() &&
                        (unwrap === undefined || unwrap === true)) {
                        if (signer === taker)
                            payRAndCloseSIxs.push(closeWSol(taker, taker, takerTokenAta));
                        else if (signer === maker)
                            payRAndCloseSIxs.push(closeWSol(maker, maker, makerTokenAta));
                    }
                    takeTx = void 0;
                    claimTx = void 0;
                    if (!!acceptedBid) return [3 /*break*/, 63];
                    return [4 /*yield*/, ix2vTx(takeIxs, cEnvOpts, signer)];
                case 62:
                    takeTx = _w.sent();
                    _w.label = 63;
                case 63:
                    if (!!claimed) return [3 /*break*/, 65];
                    return [4 /*yield*/, ix2vTx(claimIxs, cEnvOpts, signer)];
                case 64:
                    claimTx = _w.sent();
                    _w.label = 65;
                case 65: return [4 /*yield*/, connection.getLatestBlockhash()];
                case 66:
                    _q = _w.sent(), blockheight = _q.lastValidBlockHeight, blockhash_1 = _q.blockhash;
                    bTTakeAndClose = [];
                    priority = 0;
                    if (takeTx) {
                        bTTakeAndClose.push({
                            tx: takeTx,
                            description: DESC.takeSwap,
                            details: takeArgs,
                            priority: priority,
                            status: "pending",
                            blockheight: blockheight,
                        });
                        priority++;
                    }
                    else
                        console.log("no takeSwapTx");
                    if (claimTx) {
                        bTTakeAndClose.push({
                            tx: claimTx,
                            description: DESC.claimSwap,
                            details: takeArgs,
                            priority: priority,
                            status: "pending",
                            blockheight: blockheight,
                        });
                        priority++;
                    }
                    else
                        console.log("no takeSwapTx");
                    _s = (_r = bTTakeAndClose).push;
                    _v = {};
                    return [4 /*yield*/, ix2vTx(payRAndCloseSIxs, cEnvOpts, signer)];
                case 67:
                    _s.apply(_r, [(_v.tx = _w.sent(),
                            _v.description = DESC.payRoyalties,
                            _v.details = takeArgs,
                            _v.priority = priority,
                            _v.status = "pending",
                            _v.blockheight = blockheight,
                            _v)]);
                    bTTakeAndClose.map(function (b) { return (b.tx.message.recentBlockhash = blockhash_1); });
                    return [2 /*return*/, bTTakeAndClose];
                case 68:
                    error_1 = _w.sent();
                    console.log("error init", error_1);
                    throw {
                        blockchain: "solana",
                        status: "error",
                        message: error_1,
                        swapDataAccount: swapDataAccount,
                    };
                case 69: return [2 /*return*/];
            }
        });
    });
}
